// jshint esversion: 8
import idxById from '@/utils/idxById';
const setProperty = (state, property, value) => state[property] = value;
export default {
  SET_DATA: (state, payload) => setProperty(state, 'data', payload),
  SET_SAVED: (state, payload) => setProperty(state, 'saved', payload),
  PUSH_DATA: (state, payload) => state.data.push(payload),
  PUSH_SAVED: (state, payload) => state.saved.push(payload),
  UPDATE_BY_ID: (state, payload, id) => state.data[idxById(state.data, id)] = payload
};
